/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharekindvisit2Inputs */

const en_sharekindvisit2 = /** @type {(inputs: Sharekindvisit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit`)
};

const de_sharekindvisit2 = /** @type {(inputs: Sharekindvisit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuch`)
};

/**
* | output |
* | --- |
* | "Visit" |
*
* @param {Sharekindvisit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharekindvisit2 = /** @type {((inputs?: Sharekindvisit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharekindvisit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharekindvisit2(inputs)
	return de_sharekindvisit2(inputs)
});
export { sharekindvisit2 as "shareKindVisit" }